// extracted by mini-css-extract-plugin
export default {"aspectWrapper":"ListAnItemCard_aspectWrapper__3NPxt","content":"ListAnItemCard_content__105sM","button":"ListAnItemCard_button__2d9k9","textRow":"ListAnItemCard_textRow__veV8y"};